import React, { useState } from 'react';
import { Document } from '../../gql/graphql';
import { DocumentPermissions } from '../../pages/document-wizard/shared/hooks/use-document-team-permissions/use-document-team-permissions';
import { DocumentStatusEnum } from '../../shared/constants/document';

import DocumentActionsDropdownContainer from '../document-table/DocumentActionsDropdownContainer';
import { DocumentAccessLabelsEnum } from '../document-table/helpers/documentDefinitionHelpers';

import { ReactComponent as DocumentCheckIcon } from '../../shared/icons/document-check-icon.svg';
import { ExtractedTermsSlideout } from '../extractedTermsSlideout';
// import { formatDate } from '../../utils/date';
import styles from './styles.module.scss';

export interface DocData {
  id: string;
  name: string;
  status?: string | null;
  document: Document;
  access: DocumentAccessLabelsEnum;
  onClick?: () => void;
}

interface MobileDocItemProps {
  doc: DocData;
  teamId: string;
  dealId: string;
  isDealShared?: boolean;
  permissions: DocumentPermissions;
  handleEdit: (...params: any) => void;
  onClick?: () => void;
}

export const MobileDocItem: React.FC<MobileDocItemProps> = ({
  doc,
  teamId,
  dealId,
  onClick,
  isDealShared,
  permissions,
  handleEdit,
}) => {
  const documentId = doc.document.id;
  const hasCurrentTeamPossession = doc.document.currentTeamPossession;
  const documentStatus = doc.document.status;
  const isDocumentCreator = doc.document.currentUserRole === 'creator';
  const [isExtractedDataOpen, setIsExtractedDataOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    handleEdit(documentId, hasCurrentTeamPossession, documentStatus);
  };

  return (
    <>
      <div className={styles.docItem} onClick={handleClick}>
        <div className={styles.docItem__header}>
          <div className={styles.docItem__title}>{doc.name}</div>
          <div className={styles.docItem__actions}>
            {doc.document.extractedDocumentTerm && (
              <button
                className={styles.docItem__extractedDataIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsExtractedDataOpen(true);
                }}
                aria-label="View extracted data"
              >
                <DocumentCheckIcon />
              </button>
            )}
            <DocumentActionsDropdownContainer
              teamId={teamId}
              dealId={dealId}
              isDealShared={!!isDealShared}
              isDocumentCreator={isDocumentCreator}
              permissions={permissions}
              viewAction={() => handleEdit(documentId, hasCurrentTeamPossession, documentStatus)}
              documentData={doc.document}
              dropdownId={documentId}
            />
          </div>
        </div>
        <div className={styles.docItem__footer}>
          <div className={styles.docItem__creator}>Access: {doc.access}</div>
          <div className={styles.docItem__status}>
            <span className={`${styles.statusPill} ${styles[`statusPill--${(doc.status || 'draft').toLowerCase().replace(/\s+/g, '-')}`]}`}>
              {doc.status === DocumentStatusEnum.PREPARING_TO_SIGN ? 'Preparing To Sign' : doc.status}
            </span>
          </div>
        </div>
      </div>
      {isExtractedDataOpen && doc.document.extractedDocumentTerm && (
        <ExtractedTermsSlideout
          isOpen={isExtractedDataOpen}
          onClose={() => setIsExtractedDataOpen(false)}
          documentId={documentId}
          documentName={doc.name}
          extractedTerm={doc.document.extractedDocumentTerm as any}
          canEdit={permissions.hasEditPermission}
          dealId={dealId}
        />
      )}
    </>
  );
};
